<template>
  <div class="add-node-btn-box">
    <div class="add-node-btn">
      <el-popover placement="right-start" width="300">
        <div class="add-node-popover-body">
          <div class="add-node-popover-item" @click="addNode(1)">
            <img src="../../assets/img/audit.png" class="iconfont" />
            <span>审核人</span>
          </div>
          <div class="add-node-popover-item" @click="addNode(2)">
            <div class="item-wrapper">
              <img src="../../assets/img/embranchment.png" class="iconfont" />
            </div>
            <span>条件分支</span>
          </div>
          <div class="add-node-popover-item" @click="addNode(3)">
            <div class="item-wrapper">
              <img src="../../assets/img/merge.png" class="iconfont" />
            </div>
            <span>结果合并</span>
          </div>
          <div class="add-node-popover-item" @click="addNode(4)" v-if="isNode">
            <div class="item-wrapper">
              <img src="../../assets/img/subflow.png" class="iconfont" />
            </div>
            <span>子流程</span>
          </div>
          <div class="add-node-popover-item" @click="addNode(5)">
            <div class="item-wrapper">
              <img src="../../assets/img/transaction.png" class="iconfont" />
            </div>
            <span>办理人</span>
          </div>
          <div class="add-node-popover-item" @click="addNode(6)">
            <div class="item-wrapper">
              <img src="../../assets/img/Slice114@3x.png" class="iconfont" />
            </div>
            <span>抄送人</span>
          </div>
          <div class="add-node-popover-item" @click="addNode(7)">
            <div class="item-wrapper">
              <img src="../../assets/img/Slice110@3x.png" class="iconfont" />
            </div>
            <span>归档人</span>
          </div>
          <div class="add-node-popover-item" @click="addNode(8)" v-if="userType == 'user'">
            <div class="item-wrapper">
              <img src="../../assets/img/Slice11@3x.png" class="iconfont" />
            </div>
            <span>连接器</span>
          </div>
        </div>
        <el-button class="btn" slot="reference" @click="getNodeData">
          <!-- <i class="el-icon-plus iconfont"></i> -->
          <img class="iconfont" src="../../assets/img/plus.png" />
        </el-button>
      </el-popover>
    </div>
  </div>
</template>

<script>
import { mapMutations } from "vuex";
export default {
  props: ["childNodeP", "nodeList"],
  data() {
    return {
      visible: false,
      isNode: true,
      userType: sessionStorage.getItem('userType')
    };
  },
  created() {
    console.info(this.childNodeP);
  },
  methods: {
    ...mapMutations([
      "setInitiator",
      "setInitiatorData",
      "setAudit",
      "setAuditData",
      "setMake",
      "setMakeData",
      "setCondition",
      "setConditionData",
      "setMerge",
      "setFlow",
      "setFlowData",
      "setNotifier",
      "setNotifierData",
      "setFiling",
      "setFilingData",
      "setConnector",
      "setConnectorData"
    ]),
    getNodeData() {
      console.info(this.nodeList);
      if (this.nodeList.fork == "gather") {
        this.isNode = false;
      } else {
        this.isNode = true;
      }
    },
    addNode(val) {
      console.info(this.nodeList);
      let data = {};
      if (val == 1) {
        let id = this.genUid();
        if (this.childNodeP) {
          this.childNodeP.prevId = id + "";
        }
        data = {
          defaultName: false,
          name: "审批者",
          type: "approver",
          nodeId: id,
          prevId: "",
          error: true,
          properties: {
            activateType: "",
            agreeAll: "",
            notifierOptional: 0,
            approvals: [],
            formNotifiers: [],
            actionerRules: [
              {
                type: "target_approval",
                paramKey: "",
                auditDestination: 1,
                auditDestinationChecked: false,
                approvals: [],
                formNotifiers: [],
                level: "",
                levels: [],
                labels: [],
                deptDepth: "",
                formula: "",
                subType: "",
                autoUp: true,
                actType: "null",
                multi: 0,
                select: ["allStaff"],
                range: {
                  labels: [],
                  approvals: [],
                  allStaff: null,
                },
                empty: false,
              },
            ],
            buttonConfig: {
              nodeId: id,
              apostitlleEffective: 0,
              buttonConfig: [],
              apostilleButtonConfig: []
            },
            noneActionerAction: "auto",
            pickActioners: [],
            approvalType: "MANUAL",
            radio: "",
            formConfigPropertiesVOList: [],
          },
          childNode: this.childNodeP,
        };
        this.setAudit(true);
        this.setAuditData({ value: data, flag: false, id: this._uid });
      } else if (val == 2) {
        let id = this.genUid();
        let nodesId = this.genUid1();
        let nodesId1 = this.genUid2();
        if (this.childNodeP) {
          this.childNodeP.prevId = id + "";
        }
        data = {
          defaultName: false,
          name: "条件",
          type: "route",
          nodeId: id,
          prevId: "",
          conditionNodes: [
            {
              type: "condition",
              name: "条件分支1",
              priorityLevel: 1,
              conditions: [],
              childNode: this.childNodeP,
              prevId: id,
              nodeId: nodesId,
              error: true,
            },
            {
              type: "condition",
              name: "条件分支2",
              priorityLevel: 2,
              conditions: [],
              childNode: null,
              prevId: id,
              nodeId: nodesId1,
              error: true,
            },
          ],
        };
      } else if (val == 3) {
        let id = this.genUid();
        let nodesId = this.genUid1();
        let nodesId1 = this.genUid2();
        console.info(id);
        console.info(nodesId);
        console.info(nodesId1);
        if (this.childNodeP) {
          this.childNodeP.prevId = id + "";
          this.handleGatherCondition(this.childNodeP, 1);
          console.info(this.childNodeP);
        }
        data = {
          type: "gather",
          defaultName: false,
          name: "条件",
          nodeId: id,
          prevId: "",
          properties: {
            percent: "",
            gatherPass: 0
          },
          conditionNodes: [
            {
              type: "condition",
              name: "分支1",
              priorityLevel: 1,
              childNode: this.childNodeP,
              fork: "gather",
              prevId: id,
              nodeId: nodesId,
            },
            {
              type: "condition",
              name: "分支2",
              priorityLevel: 2,
              fork: "gather",
              prevId: id,
              nodeId: nodesId1,
              childNode: null,
            },
          ],
        };
      } else if (val == 4) {
        let id = this.genUid();
        if (this.childNodeP) {
          this.childNodeP.prevId = id + "";
          this.handleGatherCondition(this.childNodeP);
        }

        data = {
          defaultName: false,
          name: "子流程",
          type: "subProcess",
          nodeId: id,
          prevId: "",
          fork: "subProcess",
          error: true,
          subProcess: {
            id: "",
            parentToSon: [],
            sonToParent: [],
          },
          childNode: this.childNodeP,
        };

        this.setFlow(true);
        this.setFlowData({ value: data, flag: false, id: this._uid });
      } else if (val == 5) {
        let id = this.genUid();
        if (this.childNodeP) {
          this.childNodeP.prevId = id + "";
        }
        data = {
          defaultName: false,
          name: "办理人",
          type: "audit",
          nodeId: id,
          error: true,
          prevId: "",
          properties: {
            activateType: "",
            agreeAll: "",
            approvals: [],
            formNotifiers: [],
            actionerRules: [
              {
                type: "target_approval",
                paramKey: "",
                approvals: [],
                level: "",
                levels: [],
                labels: [],
                deptDepth: "",
                formula: "",
                subType: "",
                autoUp: false,
                actType: "and",
                multi: 0,
                select: ["allStaff"],
                range: {
                  labels: [],
                  approvals: [],
                  allStaff: null,
                },
                empty: false,
              },
            ],
            buttonConfig: {
              nodeId: id,
              apostitlleEffective: 0,
              buttonConfig: [],
              apostilleButtonConfig: []
            },

            formConfigPropertiesVOList: [],
            noneActionerAction: "auto",
            pickActioners: [],
            radio: "",
            approvalType: "MANUAL",
          },
          childNode: this.childNodeP,
        };
        this.setMake(true);
        this.setMakeData({ value: data, flag: false, id: this._uid });
      } else if (val == 6) {
        let id = this.genUid();
        if (this.childNodeP) {
          this.childNodeP.prevId = id + "";
        }
        data = {
          defaultName: false,
          name: "抄送人",
          type: "notifier",
          nodeId: id,
          prevId: "",
          error: true,
          properties: {
            actionerRules: [{
              type: "target_approval",
              paramKey: "",
              approvals: [],
              level: "",
              levels: [],
              labels: [],
              deptDepth: "",
              formula: "",
              subType: "",
              autoUp: false,
              actType: "and",
              multi: 0,
              select: ["allStaff"],
              range: {
                labels: [],
                approvals: [],
                allStaff: null,
              },
              empty: false,
            }],

            activateType: "",
            agreeAll: "",
            notifierOptional: 0,
            approvals: [],
            formNotifiers: [],
            formConfigPropertiesVOList: [],
            buttonConfig: {
              nodeId: id,
              apostitlleEffective: 0,
              buttonConfig: [],
              apostilleButtonConfig: []
            }

          },
          childNode: this.childNodeP,
        };
        this.setNotifier(true);
        this.setNotifierData({ value: data, flag: false, id: this._uid });
      } else if (val == 7) {
        let id = this.genUid();
        if (this.childNodeP) {
          this.childNodeP.prevId = id + "";
        }
        data = {
          defaultName: false,
          name: "归档人",
          type: "archiver",
          nodeId: id,
          prevId: "",
          error: true,
          properties: {
            activateType: "",
            agreeAll: "",
            approvals: [],
            formNotifiers: [],
            formConfigPropertiesVOList: [],
          },
          childNode: this.childNodeP,
        };
        this.setFiling(true);
        this.setFilingData({ value: data, flag: false, id: this._uid });
      } else if (val == 8) {
        let id = this.genUid();
        if (this.childNodeP) {
          this.childNodeP.prevId = id + "";
        }
        data = {
          defaultName: false,
          name: "连接器",
          type: "connector",
          nodeId: id,
          prevId: "",
          error: true,
          connectorProcess: {
            connectorId: "",
            queryDataBinding: [{
              dataSourceDeliveryPair: {
                key: '',
                type: ''
              },
              formDataDeliveryPair: {
                key: '',
                type: '',
                mode: "",
                label: ""
              }
            }],
            bodyDataBinding: [{
              dataSourceDeliveryPair: {
                key: '',
                type: ''
              },
              formDataDeliveryPair: {
                key: '',
                type: '',
                mode: "",
                label: ""
              }
            }],
          },
          childNode: this.childNodeP,
        };
        this.setConnector(true);
        this.setConnectorData({ value: data, flag: false, id: this._uid });
      }

      if (this.nodeList.fork == "gather") {
        data.fork = "gather";
      } else if (this.nodeList.type == "gather") {
        data.fork = "gather1";
      } else if (this.nodeList.fork == "gather1") {
        data.fork = "gather1";
      } else if (this.nodeList.fork == "subProcess") {
        data.fork = "subProcess";
      }
      this.$emit("update:childNodeP", data);
      this.$emit("addNode", data, val);
    },

    handleGatherCondition(childNodeP, val) {
      if (val == 1) {
        childNodeP.fork = "gather";
      } else {
        childNodeP.fork = "subProcess";
      }
      if (childNodeP.childNode != null) {
        console.info(childNodeP.childNode);
        this.handleGatherCondition(childNodeP.childNode, val);
      }
    },
    // 随机产生uid
    genUid() {
      let genUidsoup =
        "0123456789";
      var length = 10;
      var soupLength = genUidsoup.length;
      var id = [];
      for (var i = 0; i < length; i++) {
        id[i] = genUidsoup.charAt(Math.random() * soupLength);
      }
      return id.join("");
    },
    // 随机产生uid
    genUid1() {
      let genUidsoup =
        "0123456789";
      var length = 15;
      var soupLength = genUidsoup.length;
      var id = [];
      for (var i = 0; i < length; i++) {
        id[i] = genUidsoup.charAt(Math.random() * soupLength);
      }
      return id.join("");
    },
    // 随机产生uid
    genUid2() {
      let genUidsoup =
        "0123456789";
      var length = 20;
      var soupLength = genUidsoup.length;
      var id = [];
      for (var i = 0; i < length; i++) {
        id[i] = genUidsoup.charAt(Math.random() * soupLength);
      }
      return id.join("");
    },
  },
};
</script>

<style lang="scss">
.add-node-popover-body {
  display: flex;
  flex-wrap: wrap;

  .add-node-popover-item {
    width: 100px;
    margin-right: 10px;
    cursor: pointer;
    color: #191f25 !important;
    background: #fafbfb;
    display: flex;
    justify-content: center;
    padding: 18px 18px;
    align-items: center;
    flex-wrap: nowrap;
    border: 1px solid #fafbfb;
    border-radius: 5px;
    margin-bottom: 10px;

    .iconfont {
      width: 20px;
      height: 20px;
      margin-right: 10px;
    }

    span {
      white-space: nowrap;
    }

    &:hover {
      border: 1px solid #00000033;
      border-radius: 5px;
    }
  }
}
</style>
<style lang="scss" scoped>
.btn {
  display: flex;
  justify-content: center;
  align-items: center;

  .iconfont {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 20px !important;
    height: 20px !important;
    // margin-right: 10px;
  }
}
</style>